// export const userAPI = "http://localhost:4000/";
// export const userAPI = "https://untitledlegacy.online/";
export const userAPI = "https://acadexa-server.onrender.com"
// export const adminAPI = "http://localhost:4000/admin/";
// export const adminAPI = "https://untitledlegacy.online/admin/";
export const adminAPI = "https://acadexa-server.onrender.com/admin"
// export const tutorAPI = "http://localhost:4000/tutor/"
// export const tutorAPI = "https://untitledlegacy.online/tutor/"
export const tutorAPI = "https://acadexa-server.onrender.com/tutor"